// Module
var code = `<rbs-header></rbs-header> <rb-competitive-bid-view load-bid-function="VM.loadBidFunction" recipient-email-address-fn="VM.recipientEmailAddressFn"></rb-competitive-bid-view> `;
// Exports
export default code;